// components/onboarding/TrainerOnboarding.jsx
import React from 'react';
import { TrainerOnboardingProvider } from '../../context/TrainerOnboardingContext';
import TrainerOnboardingWelcomeModal from './TrainerOnboardingWelcomeModal';
import TrainerOnboardingOverlay from './TrainerOnboardingOverlay';
import TrainerOnboardingTooltip from './TrainerOnboardingTooltip';

/**
 * TrainerOnboarding
 *
 * Orchestrator component that wraps and renders all onboarding components
 * for the Trainer role. Should be placed inside TrainerProvider but outside
 * the main layout components.
 */
const TrainerOnboarding = () => {
    return (
        <>
            {/* Welcome modal for first-time users */}
            <TrainerOnboardingWelcomeModal />

            {/* Overlay with spotlight effect */}
            <TrainerOnboardingOverlay />

            {/* Tooltip with step instructions */}
            <TrainerOnboardingTooltip />
        </>
    );
};

/**
 * TrainerOnboardingWrapper
 *
 * Wrapper that includes the TrainerOnboardingProvider context.
 * Use this when you need to wrap components with the provider.
 */
export const TrainerOnboardingWrapper = ({ children }) => {
    return (
        <TrainerOnboardingProvider>
            {children}
            <TrainerOnboarding />
        </TrainerOnboardingProvider>
    );
};

export default TrainerOnboarding;
